import { motion } from 'framer-motion'

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
}

/**
 * Standard section heading block.
 *
 * Props:
 *   eyebrow   — small uppercase label above the title (primary pink pill)
 *   title     — main H2 in Fredoka One
 *   subtitle  — supporting paragraph below title
 *   centered  — centers all text (default: true)
 *   light     — white text variant for dark/gradient backgrounds
 *   className — additional wrapper classes
 */
export default function SectionTitle({
  eyebrow,
  title,
  subtitle,
  centered  = true,
  light     = false,
  className = '',
}) {
  return (
    <motion.div
      variants={fadeUp}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: '-60px' }}
      className={[
        centered ? 'text-center' : '',
        'mb-12',
        className,
      ].join(' ').trim()}
    >
      {/* Eyebrow pill */}
      {eyebrow && (
        <p
          className={[
            'eyebrow inline-block mb-4 px-5 py-1.5 rounded-full text-xs',
            light
              ? 'bg-white/20 text-white border border-white/30'
              : 'bg-primary/10 text-primary',
          ].join(' ')}
        >
          {eyebrow}
        </p>
      )}

      {/* Title — Fredoka One via font-display */}
      <h2
        className={[
          'font-display text-3xl md:text-4xl lg:text-5xl leading-tight mb-4',
          light ? 'text-white' : 'text-ink',
        ].join(' ')}
      >
        {title}
      </h2>

      {/* Subtitle — Nunito via font-body */}
      {subtitle && (
        <p
          className={[
            'font-body text-lg md:text-xl leading-relaxed',
            centered ? 'max-w-2xl' : '',
            centered ? 'mx-auto'   : '',
            light ? 'text-white/80' : 'text-ink-muted',
          ].join(' ').trim()}
        >
          {subtitle}
        </p>
      )}
    </motion.div>
  )
}
